import React, { useEffect } from "react";
import { useJobConfigurationContext } from "../../../../contexts/JobConfigurationContext";
import ConfigurationDialogBase from "./ConfigurationDialogBase";
import NavigationStepper from "../NavigationStepper";
import GeneralConfigurationSection from "./Components/GeneralConfigurationSection";
import FilterSection from "./Components/FilterSection";
import UserSection from "./Components/UserSection";

function JobConfigurationDialog({selectedUsers }) {
  const {
    activeJob,
    currentScreen,
    setCurrentScreen,
    filters,
    setFilters,
    setSelectedUsers,
    pipelineJobName,
    setPipelineJobName,
    validateFields,
    saveJob,
    errors,
  } = useJobConfigurationContext();

  const handleSave = () => {
    if (validateFields()) {
      saveJob();
      setPipelineJobName("");
    }
  };
  
  useEffect(() => {
    if (currentScreen < 0)
    {
      setCurrentScreen(0);
    }
    if (currentScreen > 3 - 1)
    {
      setCurrentScreen(3 - 1);
    }
  }, [currentScreen])

  useEffect(() => {
      console.log("Updated selectedUsers:", selectedUsers);
      console.log("Updated activeJob:", activeJob);
  }, [selectedUsers, activeJob]); // ✅ Ensures it updates

  return (
    <ConfigurationDialogBase
      activeJob={activeJob}
      handleSave={handleSave}
      error={errors.general}
    >
      <NavigationStepper
        currentScreen={currentScreen}
        setCurrentScreen={setCurrentScreen}
        numScreens={3} sx={{maxWidth: "100%", overflow: "hidden"}}
      />
      {currentScreen === 0 && <GeneralConfigurationSection />}
      {currentScreen === 1 && (
        <FilterSection filters={filters} setFilters={setFilters} />
      )}
      {currentScreen === 2 && (
        <UserSection
          selectedUsers={selectedUsers}
          setSelectedUsers={setSelectedUsers}
        />
      )}
    </ConfigurationDialogBase>
  );
}

export default JobConfigurationDialog;
